import { Component, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

@Component({
    selector: 'app-multi-select-dropdown',
    templateUrl: './multi-select-dropdown.component.html',
    styleUrls: ['./multi-select-dropdown.component.scss']
})
export class MultiSelectDropdownComponent {
    @Input() options: { id: number | string, name: string }[] = [];
    @Input() selectedIds: (number | string)[] = [];
    @Output() selectionChange = new EventEmitter<{ id: number | string, name: string }[]>();

    searchTerm: string = '';
    isOpen: boolean = false;
    selectedOptions: { id: number | string, name: string }[] = [];

    constructor(private eRef: ElementRef) { }

    toggleDropdown() {
        this.isOpen = !this.isOpen;
    }

    @HostListener('document:click', ['$event'])
    handleOutsideClick(event: Event) {
        if (this.isOpen && !this.eRef.nativeElement.contains(event.target)) {
            this.isOpen = false;
        }
    }

    ngOnChanges() {
        if (this.options?.length && this.selectedIds?.length) {
            this.selectedOptions = this.options.filter(opt =>
                this.selectedIds.includes(opt.id)
            );
            this.selectionChange.emit(this.selectedOptions);
        }
    }

    isSelected(option: any): boolean {
        return this.selectedOptions.some(o => o.id === option.id);
    }

    toggleSelection(option: any) {
        if (this.isSelected(option)) {
            this.selectedOptions = this.selectedOptions.filter(o => o.id !== option.id);
        } else {
            this.selectedOptions.push(option);
        }
        this.selectionChange.emit(this.selectedOptions);
    }

    removeBadge(option: any, event: Event) {
        event.stopPropagation();
        this.selectedOptions = this.selectedOptions.filter(o => o.id !== option.id);
        this.selectionChange.emit(this.selectedOptions);
    }

    get filteredOptions() {
        return this.options.filter(opt =>
            opt.name.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
    }
}
